module.exports = __webpack_public_path__ + "static/media/img_columbario.08030ead.jpg";